import { useTranslation } from 'react-i18next';

import './style.scss';
import { ReactComponent as Printer } from '@assets/images/Printer.svg';

export const PrintReceipt = () => {
  const { t } = useTranslation();

  return (
    <div className="order-confirmation__print" onClick={print}>
      <Printer />
      <span className="order-confirmation__print-title">
        {t('confirmation.printReceipt')}
      </span>
    </div>
  );
};
